import { Stack } from '@mui/material';
import { GettingStartNote } from '../../../Common/GettingStartNote';
import { UploadFileArea } from '../UploadFileArea';
import { FileNote } from '../../../Common/FileNote';
import { BackButton } from '../BackButton';
import { useContext } from 'react';
import { CannabisContext } from 'Context/CannabisContext';

export const GettingStartedSection = () => {
  const { isFileError } = useContext(CannabisContext);
  return (
    <Stack sx={{ gap: '32px', maxWidth: '800px', m: '0 auto' }}>
      <GettingStartNote isFileError={isFileError} />
      <UploadFileArea />
      <FileNote />
      <BackButton />
    </Stack>
  );
};
